// extracted by mini-css-extract-plugin
module.exports = {"postPage":"PressePostPage_postPage__EDizr"};